module.exports = __webpack_public_path__ + "img/sec2mob.b4868793.png";